/** The codelist resolving the ids behind the `vehicleCategory` filter and response field */
export const VEHICLE_CATEGORY_CODELIST_ID = 'vehicleCategory';
